import React from "react"
import PageTransition from 'gatsby-plugin-page-transitions';
// import { Link } from "gatsby"
import Layout from "../components/layout"
import VideoCover from "../components/video-cover"
import ImageCover from "../components/image-cover"
import RealisationSolution from "../components/realisation-solutions"
import LastRealisation from "../components/last-realisation"
import SEO from "../components/seo"

class IndexPage extends React.Component {

  render = () => (

      <Layout>

        <SEO title="" keywords={["it services for businesses","service business","it services solution","in service business","it company","services: processes and","marketing service","manage it service","business process outsourcing companies","it solutions","infrastructure and services","informatique consulting","conseil en informatique","entreprise conseil informatique","consultant en informatique","site conseil informatique","recrutement consultant informatique","recherche consultant informatique","consultant informatique emploi","service conseil informatique","consultant securité informatique","conseil marketing paris","offre consultant informatique","entreprise developpement informatique","entreprise développement informatique","externalisation informatique","cloud server","cloud service","cloud technology","cloud","cloud computing","le cloud computing","développement cloud","hybrid cloud","cloud security","cloud hosting","hébergement cloud","azure","datacenter","le cloud informatique","informatique cloud","cloud erp","migration cloud","cloud entreprise","data center","sécurité dans le cloud","sécurité du cloud","sécurité du cloud computing","formation cloud","applications","oracle cloud","cloud","cloud server","cloud service","cloud technology","azure","cloud computing","hybrid cloud","cloud security","public cloud","cloud storage","serveur cloud","le cloud computing","cloud stockage","serveur cloud privé","cloud entreprise","cloud privé entreprise","data center","développement cloud","migration cloud","cloud privé","logiciel cloud","hébergement cloud","solution stockage cloud","sécurité dans le cloud","cybersécurité","cyber sécurité","sécurité informatique","sécurité sur internet","securite informatique","sécurité web","formation cyber sécurité","sécurité it","formation cybersécurité","sécurité développement informatique","informatique sécurité","it security","information security","sécurité logicielle","securité informatique","la sécurité informatique","sécurité des systèmes","audit de sécurité","sécurité information","sécurité des données","sécurité données","securite web","la sécurité des réseaux","sécurité système informatique cours","sécurité ordinateur","digital","digital marketing","digital strategy","consultant digital","digital transformation","externalisation","externalisation informatique","business services","services conseils","service conseil","prestation de services","entreprise consultant ingénieur","conseils en entreprise","formation consultant stratégie","formation conseil en stratégie","consultant stratégie","consultant stratégie entreprise","service aux entreprises","service client","consultant conseil","conseil transformation","les services aux entreprises","ingénieur consultant","consultant en informatique","ingénieur conseil","conseil stratégie entreprise","conseils en management","consultant logistique","entreprise de conseil en stratégie","métiers stratégie","technologie","nouvelle technologie","+formation +intelligence +artificielle","artificial intelligence","intelligence artificielle france","artificielle intelligence","intelligence artificielle ia","intelligence artificielle","expert intelligence artificielle","une intelligence artificielle","application intelligence artificielle","ai","robot intelligence artificiel","machine learning","intelligence","ia","ai intelligence","artifical intelligence","ai intelligent","artificial inteligence","ai technology","intelligence articielle","artificial artificial intelligence","ai platform","machine intelligence","ai artificial intelligence","ai and machine learning"]} />

        <main id="wall">

          { /* <section className="scroll-section"> */}
            <VideoCover
              title="Conseil, technologie et Transformation digitale"
              videoUrl="/video/test.mp4"
            />
          {/* </section> */}


          { /* <section className="scroll-section"> */}
            <ImageCover
              title="Transformation digitale"
              content="« Ne pas avancer, c’est reculer ». Face à un marché mouvant, l’entreprise doit sans cesse démontrer son dynamisme et sa capacité d’innovation et d’adaptation. Dans ce passage obligatoire qu’est la transformation digitale, Utopie vous accompagne de manière profonde et accélérée."
              image="/img/hero/transformationinnovation.jpg"
              classDiv="hero--transformationdigitale"
              btn={{
                value: "En savoir plus",
                action: "/transformation-innovation"
              }}
            />
          {/* </section> */}

          { /* <section className="scroll-section"> */}
            <ImageCover
              title="Développement et maintenance"
              content="Nous concevons, transformons et optimisons la manière dont vos serveurs et applications raisonnent et échangent avec d'autres serveurs, clients légers, applets et applications mobiles."
              image="/img/hero/dev.jpg"
              classDiv="hero--dev"
              btn={{
                value: "En savoir plus",
                action: "/developpement"
              }}
            />
          {/* </section> */}

          <LastRealisation />

          <RealisationSolution />

        </main>
      </Layout>

  )

  constructor(props) {
    super(props);
    this.state = {
      wall: null
    }
  }

  componentDidMount = () => {
    // helpers.loadCSS(cssStyle, "#pagepilling")
  }

  componentWillUnmount = () => {
    // helpers.unloadCSS("#pagepilling")
  }

}

export default IndexPage
